import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { FullpageInterstitial } from './FullpageInterstitial';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "regular-web"
    }}>{`Regular (Web)`}</h2>
    <p>{`Classic Full Page Interstitial: horizontal. Opens on internal link and can be closed by viewer. It can be triggered once
per zone.`}</p>
    <p>{`This type does not open if the screen is higher than it is tall, i.e., most mobile phones.`}</p>
    <Playground __position={0} __code={'<a href=\"#\" onClick={e => e.preventDefault()} className=\"demo-desktop\">\n  Click me\n</a>\n<FullpageInterstitial\n  zoneId={4318792}\n  frequencyType=\"clicks\"\n  firstTriggerClicks={1}\n  nextTriggerClicks={1}\n  triggerClass={[\'demo-desktop\']}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      FullpageInterstitial,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <a href="#" onClick={e => e.preventDefault()} className="demo-desktop">Click me</a>
  <FullpageInterstitial zoneId={4318792} frequencyType="clicks" firstTriggerClicks={1} nextTriggerClicks={1} triggerClass={['demo-desktop']} mdxType="FullpageInterstitial" />
    </Playground>
    <h2 {...{
      "id": "mobile"
    }}>{`Mobile`}</h2>
    <p>{`Mobile Full Page Interstitial: Opens on internal link and closed by viewer. Unlike the desktop variant, the mobile version
has no restrictions on the screen ratio.`}</p>
    <Playground __position={1} __code={'<a href=\"#\" onClick={e => e.preventDefault()} className=\"demo-mobile\">\n  Click me\n</a>\n<FullpageInterstitial\n  zoneId={4318840}\n  frequencyType=\"clicks\"\n  firstTriggerClicks={1}\n  nextTriggerClicks={1}\n  triggerClass={[\'demo-mobile\']}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      FullpageInterstitial,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <a href="#" onClick={e => e.preventDefault()} className="demo-mobile">Click me</a>
  <FullpageInterstitial zoneId={4318840} frequencyType="clicks" firstTriggerClicks={1} nextTriggerClicks={1} triggerClass={['demo-mobile']} mdxType="FullpageInterstitial" />
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={FullpageInterstitial} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      